import React, { useContext } from 'react'
import Context from '../context/Context'

const PaymentInfoCustomer = () => {
  const context = useContext(Context)

  return (
    <div>
      <div className="row mt-5">
        <div className="col-12 text-center">
          <h1>Hej {context.customer.first_name}</h1>
        </div>
      </div>
    </div>
  )
}

export default PaymentInfoCustomer
